<template>
    <div>
         <a-card style="width:100%;text-align:center;">
       <div class="table-page-search-wrapper">
        <a-form layout="inline" style="margin:20px 0px 0px 20px;">
          <a-row :gutter="12">
            <!-- <a-col :md="6" :sm="12">
              <a-form-item label="设备名称">
                <a-input v-model="query.pointName" placeholder="请输入设备名称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="设备序列号">
                <a-input v-model="query.monitorDeviceNo" placeholder="请输入设备序列号" allow-clear/>
              </a-form-item>
            </a-col> -->
            <!-- <a-col :md="6" :sm="12">
              <a-form-item label="设备类型">
                <a-select @change="handleChange" v-model="type">
                  <a-select-option v-for="(item,index) in typelist" :key="index" :value="item">
                    {{item}}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col> -->
            <a-col :md="6" :sm="12" style="display: flex">
              <a-form-item> 
                <!-- <a-button type="primary" @click="queryList">查询</a-button> -->
              <a-button type="primary" @click="Handle('add','')" v-if="isadd">新增</a-button>
              <a-button type="danger" style="margin-left: 12px" @click="deleteSelectRow()">删除</a-button>
              </a-form-item>
              <!-- <a-form-item style="margin-left: 12px">
                <a-button @click="resetList">重置</a-button>
              </a-form-item> -->

            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
        :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
        :pagination="{ pageSize: 10 }"
        bordered
      >
      <span slot="action" slot-scope="text, record">
         <a @click="Handle('edit',record.id)">编辑</a>
      </span>
      <span slot="layer" slot-scope="text, record">
         <div :id="record.id" style="width:350px;">{{record.monitorUrl}}</div>
      </span>
      </a-table>
      <a-modal
        title="添加设置"
        okText="添加"
        width="50%"
        :visible="visible"
        :confirm-loading="confirmLoading"
        @ok="handleOk"
        @cancel="handleCancel"
      >
        <a-form :form="addOrUpdateForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
            <a-form-item label="appKey">
              <a-input
                v-decorator="['appKey', { rules: [{ required: true, message: '请输入appKey!' }] }]"
              />
            </a-form-item>
            <a-form-item label="appSecret">
              <a-input
                v-decorator="['appSecret', { rules: [{ required: true, message: '请输入appSecret!' }] }]"
              />
            </a-form-item>
            <!-- <a-form-item label="token">
              <a-input
                v-decorator="['token', { rules: [{ required: true, message: '请输入视频源地址!' }] }]"
              />
            </a-form-item>
            <a-form-item label="安装地址">
              <a-input
                v-decorator="['address', { rules: [{ required: true, message: '请输入安装地址!' }] }]"
              />
            </a-form-item> -->
        </a-form>
      </a-modal>
   </a-card>
    </div>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import qs from 'qs'
import axios from 'axios';
export default {
   mixins: [mixinViewModule],
   data(){
      return{
        queryUrl:'/pipe-network/water_works_configurations/page',
        deleteUrl: '/pipe-network/water_works_configurations/',
        queryOneUrl: '/pipe-network/water_works_configurations/',
        addOrUpdateUrl: '/pipe-network/water_works_configurations',
        appKey: '',
        appSecret: '',
        visible:false,
        confirmLoading:false,
        list: [],
        currentId: '',
        query:{
          tenantId: this.$store.state.user.info.tenantId,
          sysConf:'水源监测'
        },
        querytype: '',
        columns: [
           {
            title: 'appKey',
            dataIndex: 'appKey',
            align:"center",
            // width:150,
            // scopedSlots: { customRender: 'layer'},
          },
          {
            title: 'appSecret',
            dataIndex: 'appSecret',
            align:"center",
          },
          {
            title: 'token',
            dataIndex: 'token',
            align:"center",
          },
        //   {
        //     title: '安装地点',
        //     dataIndex: 'address',
        //     align:"center",
        //   },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            width:150,
            scopedSlots: { customRender: 'action'},
          },
        ],
        addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      }
    },
    created(){
        
    },
    mounted(){
      // this.queryList();
    },
    methods:{
      handleChange(e){
        this.type = e;
        console.log(this.type);
      },
      Handle(type,id = ""){
        this.querytype = type;
        if(type == "add"){
          this.addOrUpdateHandle();
          this.showModal();
        }else{
          this.addOrUpdateHandle(id);
          this.showModal();
        }
        console.log(this.querytype);
      },
      showModal() {
        this.visible = true;
      },
      handleOk() {
        this.addOrUpdateForm.validateFields((err, values) => {
          if (!err) {
            this.appKey = values.appKey;
            this.appSecret = values.appSecret;
            this.gettoken(values.appKey,values.appSecret);
            }
        });
      },
      handleCancel(e) {
        console.log('Clicked cancel button');
        this.visible = false;
      },
      //获取token
      gettoken(appkey,appsecret){
        let url = "https://open.ys7.com/api/lapp/token/get";
        let header = {
            'Content-Type': 'application/x-www-form-urlencoded',
            };
        let data = {appKey:appkey,appSecret:appsecret};
        axios.post(url, qs.stringify(data), {
            headers:header
        }).then((response) => {
            if(response.data.code == 200){
            // console.log(JSON.stringify(resolve.data));
            let token = response.data.data.accessToken;
            const _header = {
                'Content-Type': 'application/json',
                'Authorization': this.token,
            }
            // let _url = '/pipe-network/water_works_configurations';
            let method;
            let message;
            let params;
            console.log(this.querytype);
            if(this.querytype == "add"){
              method = "post";
              message = "新增成功";
              params = {
                appKey:this.appKey,
                appSecret:this.appSecret,
                sysConf:'水源监测',
                token:token
              }
              this.$http({
                url:this.addOrUpdateUrl,
                method:method,
                data:params,
                header:_header
              }).then((data) => {
                  this.visible = false;
                  this.$message.success(message);
                  this.queryList();
              }).catch((resolve) => {
                console.log(JSON.stringify(resolve));
              });
            }else{
              method = "put";
              message = "修改成功";
              params = {
                id:this.currentId,
                sysConf:'水源监测',
                appKey:this.appKey,
                appSecret:this.appSecret,
                token:token
              };
              this.$http({
                url:this.addOrUpdateUrl,
                method:method,
                data:params,
                header:_header
              }).then((data) => {
                  this.visible = false;
                  this.$message.success(message);
                  this.queryList();
              }).catch((resolve) => {
                console.log(JSON.stringify(resolve));
              });
            }
          }else{
            this.$message.error(resolve.data.msg);
          }
        }).catch((resolve)=>{
          // console.log(resolve.data.code);
        })
    },
    }
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
 
</style>